import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
     onUpdateColumn,
     setOrder,
     setSelectedRow,
     setPage,
     setPageSize
} from '../../../store/clientes/clientes/actions';
import { sort_by} from '../../../helpers/commons'

import { SET_MASK} from '../../../store/clientes/clientes/types';

import { FieldSet, Table } from '@sigeco/tools';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column'
    }, 
    tableWrap: {
        flex: '1 1 auto'
    }
}));

const ClientesList = () => {

    const classes = useStyles();
    const columns = useSelector(state => state.clientes.table.columns);
    const loadingStore = useSelector(state => state.clientes.store.loading);
    const order = useSelector(state => state.clientes.table.order);
    const orderBy = useSelector(state => state.clientes.table.orderBy);
    const store = useSelector(state => state.clientes.store);
    const dispatch = useDispatch();


    const handleRequestSort = (property) => {
        dispatch({ type: SET_MASK, loading: true });
        const isAsc = orderBy === property && order === 'asc';
        dispatch(setOrder(isAsc ? 'desc' : 'asc', property));
        let homes = store.data;
        homes.sort(sort_by(property, isAsc, homes[0][property]));
        dispatch({ type: SET_MASK, loading: false});
    };

    function handleChangePage(newPage) {
        dispatch(setPage(newPage));
        //dispatch(onUserList());
    }
    
    function handleChangeRowsPerPage(event) {
        dispatch(setPageSize(event.target.value));
        dispatch(setPage(0));
    }
    
    const handleResizeColumn = (column) => {
        dispatch(onUpdateColumn(column))
    };

    return (
        <FieldSet className={classes.root} iconCls="fas fa-th-list" title="Resultados">
            <div className={classes.tableWrap}>
                <Table
                    columns={columns}
                    count={store.total}
                    loading={loadingStore}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    onRowClick={items => dispatch(setSelectedRow(items))}
                    onSort={datakey => handleRequestSort(datakey)}
                     onUpdateColumn={handleResizeColumn}
                    page={store.start/store.pageSize}
                    paginate
                    rowCount={store.data.length}
                    rowGetter={index =>  store.data[index] }
                    rowsPerPage={store.pageSize}
                    selected={store.selected}
                    sortBy={orderBy}
                    sortDirection={order}
                    enableColumnResize={true}
                />
            </div>
        </FieldSet>
    )
};

export default ClientesList;
